module.exports = "https://coursera_assets.s3.amazonaws.com/images/4c4140e07498bb391f60cc549ba26efd.jpg";